import { useEffect } from "react"
import { identify, Identify } from "@amplitude/analytics-browser"
import { getMetaContentMaybe } from "~/common/get-meta-content"

export const useCollectEmail = () => {
  // Tag the experiment variant (email/control) as an Amplitude user property,
  // only while the experiment runs, so share-page conversion events stay
  // segmentable. Mirrors the top-messages experiment (use-feed-enabled).
  const variant = getMetaContentMaybe("sharepage-input-variant")
  useEffect(() => {
    if (!variant) return
    try {
      identify(new Identify().set("exp_sharepage_input_variant", variant))
    } catch {
      // ignore amplitude errors
    }
  }, [variant])

  return getMetaContentMaybe("collect-email") === "true"
}
